// extracted by mini-css-extract-plugin
export var bodySections = "_bp-8";
export var gray = "_bp-7";
export var green = "_bp-4";
export var iconContainer = "_bp-9";
export var iconWidgetContainer = "_bp-1";
export var phoneIcon = "_bp-2";
export var red = "_bp-5";
export var statusDot = "_bp-3";
export var widgetContainer = "_bp-0";
export var yellow = "_bp-6";